import React from 'react';
import PropTypes from 'prop-types';
import  Icon from './Icon';
import Button from './Button';

const SelectTransactionButton = ({ onClick }) => {
  return (
    <Button type="button" onClick={onClick} className="!bg-warning !h-12 px-10 py-8 mt-2 !text-black">
      <Icon.Transaction />
      <span className="font-medium">Select Transaction</span>
    </Button>
  )
}

SelectTransactionButton.defaultProps = {
  onClick: () => {}
}

SelectTransactionButton.propTypes = {
  onClick: PropTypes.instanceOf(Function)
}

export default SelectTransactionButton